import { mdiClose } from '@mdi/js';
import { Icon } from '@mdi/react';
import { Box, DrawerProps, Grid, Drawer as MuiDrawer, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

import { Colors } from '../../shared/colors';

interface Props extends DrawerProps {
  subtitle?: string;
  title: string;
}

const Drawer = ({ subtitle, title, children, ...props }: PropsWithChildren<Props>) => {
  return (
    <MuiDrawer
      anchor="right"
      sx={{ zIndex: { xs: 1250 } }}
      PaperProps={{
        sx: { width: { xs: '85%', sm: '60%', md: '45%', lg: '35%' } }
      }}
      {...props}
    >
      <Box display="flex" flexDirection="column" flex={1}>
        <Grid
          container
          px={subtitle ? 4 : 2}
          pt={subtitle ? 3.5 : 0}
          pb={subtitle ? 2.25 : 0}
          top={0}
          zIndex={1}
          height={subtitle ? 'auto' : { xs: 60, sm: 80 }}
          borderBottom="1px solid #D8E0EA"
          display="flex"
          bgcolor="white"
          position="sticky"
          alignItems={subtitle ? 'flex-start' : 'center'}
          justifyContent="space-between"
        >
          <Grid item minWidth={0} flex={1}>
            <Box minWidth={0}>
              <Typography
                variant={subtitle ? 'h5' : 'h6'}
                color={Colors.secondary}
                fontSize={subtitle ? 24 : undefined}
                fontWeight={subtitle ? 700 : undefined}
                lineHeight={subtitle ? 1.2 : undefined}
              >
                {title}
              </Typography>
              {subtitle && (
                <Typography color={Colors.gray1} fontSize={14} fontWeight={400} mt={0.75}>
                  {subtitle}
                </Typography>
              )}
            </Box>
          </Grid>
          <Grid item display="flex" alignItems="center" mt={subtitle ? -1 : 0}>
            <Box
              sx={{ cursor: 'pointer' }}
              onClick={() => props.onClose?.call(this, {}, 'backdropClick')}
            >
              <Icon path={mdiClose} size={1} color={Colors.gray1} />
            </Box>
          </Grid>
        </Grid>
        <Box display="flex" flex={1} minHeight={0} overflow={subtitle ? 'hidden' : undefined}>
          {children}
        </Box>
      </Box>
    </MuiDrawer>
  );
};

export default Drawer;
